export enum AmplitudeEvent {
  USER_MANAGEMENT_KEBAB = 'user_management_kebab',
  USER_MANAGEMENT_CLICK_EDIT_MENU_KEBAB = 'user_management_click_edit_menu_kebab',
  USER_MANAGEMENT_CLICK_DELETE_MENU_KEBAB = 'user_management_click_delete_menu_kebab',
  USER_MANAGEMENT_CLICK_CLOSED_CREATE_USER = 'user_management_click_closed_create_user',
  USER_MANAGEMENT_CLICK_CONTINUE_CREATE_USER = 'user_management_click_continue_create_user',
  USER_MANAGEMENT_CLICK_CLOSE_CREATE_USER = 'user_management_click_close_create_user',
  USER_MANAGEMENT_CREATE_USER = 'user_management_create_user',
  USER_MANAGEMENT_DELETE_USER = 'user_management_delete_user',
  USER_MANAGEMENT_EDIT_USER = 'user_management_edit_user',
  USER_MANAGEMENT_BUTTON_CREATE = 'user_management_button_create',
  USER_MANAGEMENT_USERS_LIMIT_REACHED = 'user_management_users_limit_reached',
  USER_MANAGEMENT_SEE_PLANS = 'user_management_see_plans',
  USER_MANAGEMENT_SORT_USERS = 'user_management_sort_users',
  USER_MANAGEMENT_FILTER_USERS = 'user_management_filter_users',
  USER_MANAGEMENT_CHANGE_CONTACT_TYPE = 'user_management_change_contact_type',
  USER_MANAGEMENT_AUTO_CHANGE_CONTACT_TYPE = 'user_management_auto_change_contact_type',
  USER_MANAGEMENT_CLICK_PURCHASE_USERS = 'user_management_click_purchase_users',
  USER_MANAGEMENT_CLICK_REGISTER_NEW_EXTRA_USERS = 'user_management_click_register_new_extra_users',
  USER_MANAGEMENT_VIEW_UPDATE_CPF_MODAL = 'user_management_view_update_cpf_modal',
  USER_MANAGEMENT_ERROR_UPDATE_CPF_MODAL = 'user_management_error_update_cpf_modal',
  USER_MANAGEMENT_CLICK_CONFIRM_UPDATE_CPF_MODAL = 'user_management_click_confirm_update_cpf_modal',
  USER_MANAGEMENT_CLICK_LOGOUT_REASON_CPF_MODAL = 'user_management_click_logout_reason_cpf_modal',
  USER_MANAGEMENT_OPEN_LOGOUT_REASON_CPF_MODAL = 'user_management_open_logout_reason_cpf_modal',
  USER_MANAGEMENT_CANCEL_LOGOUT_REASON_CPF_MODAL = 'user_management_cancel_logout_reason_cpf_modal',
}
